import { defineFcm } from '../shared/factory';

export const FCM_VIDEO_QUALITY_SCORING = defineFcm('video_quality_scoring').asBoolean().withDefault(false).toConfig({
	owner: 'squad-vaquita',
	scope: 'discussion-service',
	context: 'Supporter voices video moderation',
	description:
		'Enables quality scoring for supporter voices videos during the moderation workflow in discussion_service.',
	import: false,
});
